<template>
  <b-card>
    <b-row
      align-h="end"
      style="gap: 1rem; margin-bottom: 10px;"
    >
      <download-em-excel
        :filtro="filtroAtual"
        tipo="DTE"
        :api="apiDTE"
        :get-info-extra="montarDto"
      />
    </b-row>
    <dte-list
      ref="dteList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
    >
      <!-- campos -->
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <span
          v-if="props.column.field === 'razaoSocial' || props.column.field === 'consultadoEm' || props.column.field === 'cadastroFederal' || props.column.field === 'status'"
          @click="props.column.field === 'razaoSocial' ? $refs[`acoes${props.row.id}`].openModalHistorico(props) : null"
        >
          <span
            v-if="props.row.statusAlterado === true"
            style="font-weight: bold"
          >
            {{ props.formattedRow[props.column.field] }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </span>
      </template>

      <!-- ações -->
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          style="display: flex;"
          :filtros-rapidos="filtrosRapidos"
          @atualizar-grid="atualizarGrid()"
        />
      </template>
    </dte-list>
  </b-card>
</template>

<style lang="scss">
.modal-lg {
  max-width: 1000px !important;
}
.acoes-grid {
  display: flex !important;
}
</style>

<script>

import colunas from './shared/components/colunas'
import api from './shared/services/api'

export default {
  name: 'CndFederalVisualizacao',
  components: {
    DteList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('./shared/components/acoes/Acoes.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
  },
  data() {
    return {
      apiDTE: api,
      botoesOption: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-2',
      },
      filtros: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial', 'ConsultadoEm'], valor: null }],
      filtrosRapidos: [
        // {
        //   id: 'Invalido',
        //   colunas: ['Status'],
        //   label: 'Número de identificação inválido',
        //   valor: '-2',
        // },
        {
          id: 'NaoOptante',
          colunas: ['Status'],
          label: 'Não optante',
          valor: '-1',
        },
        {
          id: 'OptanteDTE',
          colunas: ['Status'],
          label: 'Optante DTE',
          valor: '0',
        },
        {
          id: 'OptanteSimples',
          colunas: ['Status'],
          label: 'Optante Simples',
          valor: '1',
        },
        {
          id: 'OptanteDTESimples',
          colunas: ['Status'],
          label: 'Optante DTE e Simples',
          valor: '2',
        },
        {
          id: 'SemProcuracao',
          colunas: ['Status'],
          label: 'Sem procuração',
          valor: '3',
        },
      ],
      filtroAtual: {},
      suporte: false,
    }
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  created() {
    this.visualizacao.colunas = colunas
    this.visualizacao.colunas[0].evento = this.editar
    this.visualizacao.evento = this.carregar
    this.visualizacao.allpaged = this.allPaged
  },
  methods: {
    setSuporte(isSuporte) {
      this.suporte = isSuporte
    },
    montarDto() {
      if (this.$refs.dteList) {
        const empresas = this.$refs.dteList.linhaSelecionada
        this.filtroAtual.empresasSelecionadas = !empresas ? [] : empresas
        return this.filtroAtual
      }
      return undefined
    },
    // eslint-disable-next-line no-unused-vars
    carregar(pagina, tamanhoPagina, filtros) {
      this.filtroAtual = filtros
      return api.getPaginado(pagina, tamanhoPagina, filtros)
    },
    allPaged(filtro) {
      return api.getTodasLinhas(filtro)
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.dteList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.dteList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
    atualizarGrid() {
      this.$refs.dteList.buscar()
    },
  },
}
</script>
